import { render, staticRenderFns } from "./Chemical.vue?vue&type=template&id=16659d18"
import script from "./Chemical.vue?vue&type=script&lang=js"
export * from "./Chemical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports